<div class="alert-status-wrapper">
  @if (isRead && (status === AlertStatus.New || status === null || status === undefined)) {
    <div class="status read">
      {{ 'Read' }}
    </div>
  } @else {
    <div class="status" [class]="AlertStatus[status!]">
      {{ status | alertsStatusPipe | splitByCapitalLetterPipe }}
    </div>

    @if (status == AlertStatus.Postponed && postponedTillMessage) {
      <div
        container="body"
        placement="top"
        tooltipClass="tooltip-info"
        [ngbTooltip]="postponedTillMessage"
      >
        <i class="icon ic-info-circle-16 bg-gray-700"></i>
      </div>
    }
  }
</div>
